import React, { useEffect, ReactNode } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { LastLocationState, updateLastLocationAction } from 'redux/ducks/lastLocation'

let lastLocation: LastLocationState | null = null

type LastLocationProviderProps = {
  children: ReactNode
}

const LastLocationProvider: React.FC<LastLocationProviderProps> = ({

  children,
}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  
  useEffect(() => {
    const callback = (lastLocation: LastLocationState) => {
      return dispatch(updateLastLocationAction(lastLocation))
    }
    if (lastLocation && lastLocation.pathname === location.pathname) {
      return
    }
    lastLocation = { ...location }
    callback(lastLocation)
  }, [location, dispatch])

  return <>{children}</>
}

export default LastLocationProvider


